import { match } from 'ts-pattern'

import { Schema as Schema_ } from '@blade/std-lib'

import { ZeroSlotApiKeySchema } from './zero-slot-api-key'

import type { ZeroSlotApiKey } from './zero-slot-api-key'
import type { QuotePostRequestBody } from '@blade/pathfinder-api-client'
import type {
  HeliusSender as HeliusSender_,
  ZeroSlot as ZeroSlot_,
} from '@root/entities/network/model/solana'
import type { BuildSignAndSendSwapTransactionPayloadDto } from '@root/features/secure-storage/secure-storage-service'

const HeliusSenderSchema = Schema_.Struct({
  type: Schema_.Literal('helius-sender'),
  location: Schema_.String,
})

const ZeroSlotSchema = Schema_.Struct({
  type: Schema_.Literal('0slot'),
  region: Schema_.String,
  apiKey: ZeroSlotApiKeySchema,
})

const CustomRpcSchema = Schema_.Struct({
  type: Schema_.Literal('custom'),
  url: Schema_.String,
})

export const Schema = Schema_.Union([
  HeliusSenderSchema,
  ZeroSlotSchema,
  CustomRpcSchema,
])
export interface HeliusSender {
  type: 'helius-sender'
  location: HeliusSender_.HeliusRpc
}

export interface ZeroSlot {
  type: '0slot'
  region: ZeroSlot_.RegionKey
  apiKey: ZeroSlotApiKey
}

export interface CustomRpc {
  type: 'custom'
  url: string
}

export type Rpc = HeliusSender | ZeroSlot | CustomRpc

type PathfinderArg = NonNullable<
  BuildSignAndSendSwapTransactionPayloadDto['sender']
>
export const toPathfinderArg = (rpc: Rpc) => {
  return match(rpc)
    .returnType<PathfinderArg>()
    .with({ type: 'helius-sender' }, (rpc) => ({
      kind: 'helius-sender',
      location: rpc.location.id,
    }))
    .with({ type: '0slot' }, (rpc) => ({
      kind: '0slot',
      region: rpc.region,
      apiKey: rpc.apiKey,
    }))
    .with({ type: 'custom' }, (rpc) => ({
      kind: 'custom',
      url: rpc.url,
    }))
    .exhaustive()
}

export const toPathfinderSenderType = (rpc: Rpc) => {
  return match(rpc)
    .returnType<NonNullable<QuotePostRequestBody['sender_type']>>()
    .with({ type: 'helius-sender' }, () => 'helius')
    .with({ type: '0slot' }, () => '0slot')
    .with({ type: 'custom' }, () => 'custom')
    .exhaustive()
}
